import { render, staticRenderFns } from "./createOredit.vue?vue&type=template&id=59691173"
import script from "./createOredit.vue?vue&type=script&lang=js"
export * from "./createOredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports